<template functional>
  <div style="align-content: center">
    <strong><translate-text keyTranslate="common_words.note" />:</strong>
    {{ props.row.credit_note !== null ? props.row.credit_note : 'NA' }}
    <br />
    <strong><translate-text keyTranslate="common_words.date" />:</strong>
    {{
      props.row.date_credit_note !== null ? props.row.date_credit_note : 'NA'
    }}
  </div>
</template>
<script>
export default {
  name: 'CreditDataFormatter',
};
</script>
